import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';

import {
    MODAL_TYPE_ADBLOCKER,
    MODAL_TYPE_INFORMATIVE,
    MODAL_TYPE_INTERSTITIEL
} from '../../../services/modal/constants';
import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT, TIMER_MS_INTERSTITIEL } from '../../../constants';
import { PATH_TO_PARTNER } from '../../../services/i18n/constants';
import { COOKIE_KEY_REDIRECT_AFTER_LOGIN } from '../../../constants/cookie';

import {
    fetchPartnerDiscountsIfNeeded,
    fetchPartnerMostDisplayableDiscountForUser
} from '../../../services/discount/actions';
import { showModal } from '../../../services/modal/actions';
import { doRewriteUrl } from '../../../services/interstitiel/actions';
import { fetchPartnerCouponsIfNeeded } from '../../../services/coupon/actions';
import { fetchPartnerDetailsIfNeeded } from '../../../services/partner/actions';

import { getI18nByKey } from '../../../services/i18n/selector';
import { getPartner } from '../../../services/partner/selector';

import { reformUrlExterieur } from '../../../utils';
import { getClientUrl } from '../../../utils/ssoUtil';
import { isTokenExpired } from '../../../services/authentication/utils';
import { displayableCashbackComplete } from '../../../services/partner/utils';

import HeadComponent from '../../HeadComponent';

import './InterstitielComponent.scss';

class InterstitielComponent extends React.Component {
    constructor(props) {
        super(props);
        const locationParsed = queryString.parse(props.location.search);
        const isToolbarRequest = props.location.pathname.toLowerCase().includes('toolbar');
        this.state = {
            partnerId: props.match.params.partnerId,
            couponId: props.match.params.couponId ? props.match.params.couponId : '-1',
            clickSource: props.match.params.clickSource,
            urlSource: locationParsed.urlSource ? locationParsed.urlSource : '',
            username: props.match.params.username,
            toolbarRequest: isToolbarRequest,
            isAdblockModalShowed: false,
            isInformativeModalShowed: false,
            isInInterstitielModalShowed: false,
            isInformativeModalUnderstood: false
        };
    }

    showModal = props =>
        this.props.showModal(MODAL_TYPE_INTERSTITIEL, {
            ...props,
            hideCloseButton: false,
            redirectOnClose: true
        });

    showAdBlockerModal = props => {
        const { showModal } = this.props;

        showModal(MODAL_TYPE_ADBLOCKER, {
            id: 'adblocker-modal',
            hideCloseButton: true,
            ...props
        });
        this.setState({ isAdblockModalShowed: true });
    };

    showInformativeModal = props => {
        const { showModal } = this.props;

        showModal(MODAL_TYPE_INFORMATIVE, {
            id: 'informative-modal',
            hideCloseButton: true,
            ...props,
            onConfirm: () => {
                this.setState({ isInformativeModalUnderstood: true });
            }
        });
        this.setState({ isInformativeModalShowed: true });
    };

    renderIframe = () => {
        const { urlRewritten } = this.props;

        return (
            !this.isAdblockerDetectedOrCookiesDisabled() &&
            !this.isInformativeModalRequired() &&
            urlRewritten && (
                <iframe
                    title="interstitiel"
                    src={reformUrlExterieur(urlRewritten)}
                    height="100%"
                    width="100%"
                />
            )
        );
    };

    redirect = url => {
        if (url) {
            console.log('Will be redirect in 5 seconds to', url);

            setTimeout(() => {
                window.location = url;
            }, TIMER_MS_INTERSTITIEL);
        } else {
            console.error('An error occured, no redirection');
        }
    };

    isMemberAuthenticated = () =>
        !isTokenExpired(this.props.authentication.token) &&
        this.props.authentication.isAuthenticated;

    isAdblockerDetectedOrCookiesDisabled = () =>
        this.props.adBlockerDetected || !this.props.cookiesEnabled;

    isInformativeModalRequired = () => !this.state.isInformativeModalUnderstood;

    getEffectiveUsername() {
        const { username } = this.state;

        let effectiveUsername = username;

        if (!this.isMemberAuthenticated() && !effectiveUsername) {
            if (!document.cookie) {
                return;
            }

            let cookies = document.cookie.split(';');
            let usernameCookie = cookies.find(val => val && val.includes('Pseudo='));

            if (usernameCookie) {
                // User is recognized - extract cookie value & continue with normal execution
                effectiveUsername = usernameCookie.split('=')[1];
            } else {
                return;
            }
        }

        return effectiveUsername;
    }

    redirectToPartner = () => {
        const { partner, urlRewritten } = this.props;
        const { partnerId, couponId } = this.state;
        let success = false;
        let redirectToUrl = null;
        let noRedirectionFailure = false;

        if (urlRewritten) {
            success = true;
            redirectToUrl = urlRewritten;
        } else if (partner && partner.url) {
            redirectToUrl = partner.url;
        } else {
            noRedirectionFailure = true;
            this.redirect(PATH.HOME_PATH);
        }

        this.showModal({ success, noRedirectionFailure, partnerId, couponId, redirectToUrl });
        this.redirect(redirectToUrl);
    };

    componentDidMount() {
        const {
            history,
            fetchPartnerCouponsIfNeeded,
            fetchPartnerDiscountsIfNeeded,
            fetchPartnerDetailsIfNeeded,
            fetchPartnerMostDisplayableDiscountForUser
        } = this.props;
        const { partnerId, toolbarRequest } = this.state;

        let effectiveUsername = this.getEffectiveUsername();

        // check effectiveUsername to be sure we are in toolbar scenario (and in email scenario)
        if (!this.isMemberAuthenticated() && !effectiveUsername) {
            if (toolbarRequest) {
                sessionStorage.setItem(
                    COOKIE_KEY_REDIRECT_AFTER_LOGIN,
                    this.props.location.pathname
                );
                setTimeout(() => {
                    window.location = getClientUrl();
                }, 500);
            }

            // Redirect unknown user to home page
            history.push('/');
            return;
        }

        fetchPartnerCouponsIfNeeded(partnerId);
        fetchPartnerDiscountsIfNeeded(partnerId);
        fetchPartnerDetailsIfNeeded(partnerId, false);

        if (!this.isMemberAuthenticated() && effectiveUsername) {
            fetchPartnerMostDisplayableDiscountForUser(partnerId, effectiveUsername);
        }
    }

    componentDidUpdate() {
        const {
            doRewriteUrl,
            fetchingUrlRewritten,
            errorUrlRewritten,
            urlRewritten,
            adBlockerDetected,
            cookiesEnabled
        } = this.props;
        const {
            partnerId,
            couponId,
            clickSource,
            urlSource,
            toolbarRequest,
            isAdblockModalShowed,
            isInformativeModalShowed,
            isInInterstitielModalShowed
        } = this.state;

        let effectiveUsername = this.getEffectiveUsername();

        if (
            !fetchingUrlRewritten &&
            !urlRewritten &&
            !errorUrlRewritten &&
            adBlockerDetected !== true &&
            cookiesEnabled != null
        ) {
            // Call API to rewerite URL.
            doRewriteUrl(
                partnerId,
                couponId,
                clickSource,
                urlSource,
                effectiveUsername,
                toolbarRequest,
                this.isAdblockerDetectedOrCookiesDisabled()
            );
        }

        if (this.isAdblockerDetectedOrCookiesDisabled() && !isAdblockModalShowed && urlRewritten) {
            this.showAdBlockerModal({ urlRewritten });
        }

        if (
            !this.isAdblockerDetectedOrCookiesDisabled() &&
            this.isInformativeModalRequired() &&
            !isInformativeModalShowed
        ) {
            this.showInformativeModal();
        }

        if (
            !this.isAdblockerDetectedOrCookiesDisabled() &&
            !this.isInformativeModalRequired() &&
            !isInInterstitielModalShowed
        ) {
            this.redirectToPartner();
            this.setState({ isInInterstitielModalShowed: true });
        }
    }

    render() {
        const { i18n, partner, partnerDisplayableCashbackComplete } = this.props;

        return (
            <main role="main" id="p-interstitiel">
                <HeadComponent
                    title={
                        partner &&
                        format(i18n.TITLE, partner.name, partnerDisplayableCashbackComplete)
                    }
                    description={
                        partner &&
                        format(i18n.DESCRIPTION, partner.name, partnerDisplayableCashbackComplete)
                    }
                    canonicalLink={
                        partner &&
                        `${CONTEXT_ROOT}${PATH.INTERSTITIEL_CASHBACK_PATH}${partner.id}/0`
                    }
                />

                {this.renderIframe()}
            </main>
        );
    }
}

InterstitielComponent.propTypes = {
    partner: PropTypes.object
};

const mapStateToProps = (state, props) => {
    const partnerId = props.match.params.partnerId;
    const partner = getPartner(state, partnerId);

    return {
        i18n: state.i18n.page.INTERSTITIEL,
        authentication: state.authentication,
        partner: partner,
        fetchingUrlRewritten: state.interstitiel.fetching,
        errorUrlRewritten: state.interstitiel.error,
        urlRewritten: state.interstitiel.urlRewritten,
        adBlockerDetected: state.adblocker.adBlockerDetected,
        cookiesEnabled: state.adblocker.cookiesEnabled,
        partnerDisplayableCashbackComplete: displayableCashbackComplete(
            partner,
            getI18nByKey(state, PATH_TO_PARTNER),
            false,
            false
        )
    };
};

const mapDispatchToProps = {
    doRewriteUrl,
    showModal,
    fetchPartnerCouponsIfNeeded,
    fetchPartnerDiscountsIfNeeded,
    fetchPartnerMostDisplayableDiscountForUser,
    fetchPartnerDetailsIfNeeded
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InterstitielComponent));



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/InterstitielComponent.js